import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../api/DnerhsApi";
import FormInput from "../../Controls/Input";
import Alert from "../../components/Alert";
import ResponseUtils from "../../utils/ResponseUtils";
import history from "../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import FormSelect from "../../Controls/Select";
import { findByNumeroCedula } from "services/DatosPersonalesService";
import { trackPromise } from "react-promise-tracker";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(16),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  large: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
  button: {
    margin: theme.spacing(2),
  },
  okButton: {
    color: "#fff",
    backgroundColor: "#01C12B",
    margin: theme.spacing(),
  },
  denyButton: {
    color: "#fff",
    backgroundColor: "#ff0000",
    margin: theme.spacing(),
  },
  title: {
    fontSize: 14,
  },
}));


const Form = () => {
  const classes = useStyles();
  const [sent, setSent] = useState(false);
  const params = useParams();
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [editarResponsable, setEditarResponsable] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [responsableResponseData, setResponsableResponseData] = useState({});
  const [nombreServicioOptions, setNombreServicioOptions] = useState([]);
  const methods = useForm({});
  const { handleSubmit, errors, reset, setValue } = methods;
  let { state } = useLocation();
  const [departamentosOptions, setdepartamentosOptions] = useState([]);
  const [ciudadOptions, setCiudadOptions] = useState([]);
  const tipoInstitucionOptions = [{
    id: 1,
    label: "Pública",
  },
  {
    id: 2,
    label: "Privada",
  }];
  useEffect(() => {
    const load = () => {
      try {
        getServerData();
        setEditarResponsable(false);
        if (state?.edit || state?.readOnly) {
          setIsUpdate(state?.edit===true?true:false);
          setIsReadOnly(state?.readOnly);
          setValuesForEdit();
        } else {
          setIsAddMode(true);
        }

      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const getServerData = async () => {
    try {
      const responseDepartamentos = await DnerhsApi.get("/departamentos", {
        params: { pageSize: 100 },
      });
   
      
      const responseNombreServicioOptions = await DnerhsApi.get("/servicios");
      setNombreServicioOptions(
        responseNombreServicioOptions.data.map((x) => ({
          label: x.nombre,
          id: x.id,
        }))
      );
      
      setdepartamentosOptions(
        responseDepartamentos.data.map((x) => ({
          label: x.descripcion,
          id: x.id,
        }))
      );
   

    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  };

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  }

  const setValuesForEdit = async () => {
    try {
      const { data: responseResponsables } = await DnerhsApi.get(`/instituciones/formadoras/${params.institucionFormadoraId}/responsables`);
      if(responseResponsables!=null && responseResponsables !=""){
        setEditarResponsable(true);
      }
      const { data: responsable } = await DnerhsApi.get(`/instituciones/formadoras/${params.institucionFormadoraId}`);
      setResponsableResponseData(responsable);
      const responseCiudad = await DnerhsApi.get(`/departamentos/${responsable.departamento.id}/ciudades`, {
        params: { pageSize: 100 },
      });
      setCiudadOptions(
        responseCiudad.data.map((x) => ({
          label: x.descripcion,
          id: x.id,
        }))
      );
      const formValues = {
        institucion: responsable.institucion,
        email: responsable.email,
        nombres: responsable.nombres,
        telefono: responsable.telefono,
        ley: responsable.ley,
        sede: responsable.sede,
        tipoInstitucion:(responsable.tipoInstitucionFormadora==="Pública"?1:2),
        ciudad:responsable.ciudad.id,
        copiaLey: "",
        departamento: responsable.departamento.id,      
        direccion: responsable.direccion
      };
      Object.keys(formValues).forEach((field) => {
        setValue(field, formValues[field]);
      });    

    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  };

  const onSubmit = async (data) => {

    const payload =  {
        ciudad: { id: data.ciudad },
        copiaLey: "",
        departamento: {
          id: data.departamento,
        },
        direccion: data.direccion,
        email: data.email,
        institucion: data.institucion,
        ley: data.ley,
        sede: data.sede,
        telefono: data.telefono,
        tipoInstitucionFormadora:(data.tipoInstitucion===1?"Pública":"Privada"),
        asignadas:0,
        disponibles:0,
        ocupadas:0
    };
    try {
      let url = "/instituciones/formadoras";
      if(isAddMode){
        await trackPromise(DnerhsApi.post(url, {
          ...payload,
        }));
      }else{
        let payloadput=responsableResponseData;
        payloadput.ciudad= { id: data.ciudad };
        payloadput.departamento= {
            id: data.departamento,
          };
          payloadput.direccion= data.direccion;
        payloadput.email= data.email;
        payloadput.institucion= data.institucion;
        payloadput.ley= data.ley;
        payloadput.sede= data.sede;
        payloadput.telefono= data.telefono;
        payloadput.tipoInstitucionFormadora=(data.tipoInstitucion===1?"Pública":"Privada");
        await trackPromise(DnerhsApi.put(url, {
          ...payloadput,
        }));
      }
      setSent(true)
      Alert.show(
        {
          message: "Institucion creada con éxito.",
          type: "success"
        }
      )
      history.goBack();
    } catch(error) {
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }

  }
  const changeTimeDesde  = async (e) =>{
    //setTimeDesde(e.target.value)
    const responseCiudad = await DnerhsApi.get(`/departamentos/${e.target.value}/ciudades`, {
      params: { pageSize: 100 },
    });
    setCiudadOptions(
      responseCiudad.data.map((x) => ({
        label: x.descripcion,
        id: x.id,
      }))
    );
  }
  const handleFindDatosPersonales = async (event) => {
    let {target} = event;
    
    const { data } = await trackPromise(findByNumeroCedula(target.value));
    if (data) {
      setValue("nombres", data.nombres);
      setValue("apellidos", data.apellidos);
    }
  }
  const handleHabilitar= (event) =>  {
    if(event){
      setIsReadOnly(false);
      setIsUpdate(true);
    }
   // 
  }
  return (
    <div className={classes.main}>
      <Grid item xs={12}>
        {isAddMode ? (
          <Typography
            align="center"
            variant="h5"
            color="primary"
            className={classes.form}
          >
            Datos de la Institución Formadora
          </Typography>
        ) : (
          <Typography
            align="center"
            variant="h5"
            color="primary"
            className={classes.form}
          >
            Establecimiento y usuario responsable
          </Typography>
        )}
      </Grid>
      <div>
        <FormProvider {...methods}>
          <Paper>
            <form>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
              >
                
               

                <Grid item xs={6} className={classes.form}>
                 
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      name="institucion"
                      label="Institución"
                      disabled={isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      name="sede"
                      label="Sede"
                      disabled={isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      name="telefono"
                      label="Teléfono"
                      disabled={isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      name="email"
                      label="E-mail"
                      disabled={isReadOnly}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6} className={classes.form}>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      name="direccion"
                      label="Dirección"
                      errorobj={errors}
                      required
                      disabled={isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <FormSelect
                      name="departamento"
                      label="Departamento"
                      options={departamentosOptions}
                      disabled={isReadOnly}
                      onClick={(e) => changeTimeDesde(e)}
                      errorobj={errors}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <FormSelect
                      name="ciudad"
                      label="Ciudad"
                      options={ciudadOptions}
                      disabled={isReadOnly}
                      errorobj={errors}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      type= "number"
                      name="ley"
                      label="Nº de Ley de Creación"
                      errorobj={errors}
                      required
                      disabled={isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                  <FormSelect
                    name="tipoInstitucion"
                    label="Pública/Privada"
                    options={tipoInstitucionOptions}
                    disabled={isReadOnly}
                  />
                </Grid>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </FormProvider>
      </div>

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        className={classes.form}
      >
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick={() => { history.goBack() }}
          >
            Atrás
          </Button>
        </Grid>
        {(isAddMode || isUpdate) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              Guardar
            </Button>
          </Grid>
        }
         {(isReadOnly) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={(event) => { handleHabilitar(event) }}
            >
              Editar
            </Button>
          </Grid>
        }
           {(editarResponsable) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {  history.push(`/institucionesFormadoras/editar/${responsableResponseData.id}`) }}  
            >
              Editar Responsables
            </Button>
          </Grid>
        }
        {(editarResponsable) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {  history.push(`/institucionesFormadoras/agregar/${responsableResponseData.id}`) }}  
            >
              Agregar Responsables
            </Button>
          </Grid>
        }
      </Grid>

    </div>)
};

export default Form;
